"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _employee = require("@/api/employee");
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
var _index = require("@/utils/index");
var _excel = require("@/utils/excel");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.employeesCount = 0; // verification pending employeeesCount
    this.totalEmployeesCount = 0; // all employees count
    this.rmCount = 0;
    this.profileImageUploadedCount = 0;
    this.firstLoginEmployeesCount = 0;
    this.downloadLoading = false;
    this.animationDuration = 3000;
  }
  handleSetLineChartData(type) {
    this.$emit('handleSetLineChartData', type);
  }
  async created() {
    await this.getEmployeeCount();
    await this.getTotalRmCount();
    await this.imageUploadedRMCount();
    await this.firstLoginCount();
  }
  async getEmployeeCount() {
    try {
      const result = await (0, _employee.getEmployeeProfileVerificationCount)((0, _index.getQuery)({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
      this.employeesCount = +result.total;
      this.totalEmployeesCount = +(await (0, _employee.getTotalEmployeesCount)());
    } catch (error) {
      this.$message({
        message: error.toString(),
        type: 'error'
      });
    }
  }
  async getTotalRmCount() {
    try {
      const result = await (0, _employee.getTotalRmCount)();
      this.rmCount = +result;
    } catch (error) {
      this.$message({
        message: error.toString(),
        type: 'error'
      });
    }
  }
  async imageUploadedRMCount() {
    try {
      const result = await (0, _employee.imageUploadedRMCount)();
      this.profileImageUploadedCount = +result;
    } catch (error) {
      this.$message({
        message: error.toString(),
        type: 'error'
      });
    }
  }
  async firstLoginCount() {
    try {
      const result = await (0, _employee.firstLoginCount)();
      this.firstLoginEmployeesCount = +result;
    } catch (error) {
      this.$message({
        message: error.toString(),
        type: 'error'
      });
    }
  }
  async handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['Division', 'Zone', 'Code', 'EmployeeRole', 'Name', 'Active', 'Profile Picture Submitted', 'firstLoginDate', 'firstLoginTime', 'firstLoginDay', 'lastLoginDate', 'lastLoginTime', 'lastLoginDay', 'login', 'access', 'Report download', 'MRLocation', 'AMLocation', 'RMLocation', 'ZMLocation', 'AppVersion'];
    const filterVal = ['Division', 'Zone', 'Code', 'EmployeeRole', 'Name', 'Active', 'ProfilePicture', 'firstLogin', 'lastLogin', 'login', 'access', 'download', 'MRLocation', 'AMLocation', 'RMLocation', 'ZMLocation', 'AppVersion'];
    const data = await (0, _employee.exportEmployees)();
    const data2 = (0, _index.formatJson)(filterVal, data);
    (0, _excel.exportJson2Excel)(tHeader, data2, 'EmployeesData');
    this.downloadLoading = false;
  }
  async handleWeeklyWinnerDownload() {
    this.downloadLoading = true;
    const tHeader = ['Division', 'Zone', 'RMLocation', 'Name', 'Rank', 'Score', 'MonthWeek'];
    const filterVal = ['division', 'zone', 'rmLocation', 'rm', 'rank', 'Score', 'MonthWeek'];
    const data = await (0, _employee.getWeeklyWinners)();
    const data2 = (0, _index.formatJson)(filterVal, data);
    (0, _excel.exportJson2Excel)(tHeader, data2, 'WeeklyWinnersData');
    this.downloadLoading = false;
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'PanelGroup',
  components: {
    CountTo: _vueCountTo.default
  }
})], default_1);
var _default = exports.default = default_1;